services.service('TransactionHistoryService', [
    '$q',
    'API', 'constants', 'TransactionHistoryCollection', 'TransactionHistoryModel', 'ServerTimeService', 'UserService',
    function ($q, API, Const, TransactionHistoryCollection, TransactionHistoryModel, ServerTimeService, UserService) {
        var self = this;

        self.user = null;
        self.collection = null;

        this.init = function () {
            self.user = UserService.get();
            if (!self.user.loggedIn) {
                return;
            }
        };

        this.getTransactions = function () {
            if (self.user.activeTradingAccount) {
                return API.transactionHistory()
                    .then(checkResponse)
                    .then(function (response) {
                        initCollection();
                        return response;
                    })
                    .then(initTransactions)
            }

            initCollection();
            return $q.resolve();
        };

        function initCollection() {
            self.collection = new TransactionHistoryCollection();
        }

        function initTransactions(data) {
            data.transactions.forEach(function(transaction){
                self.collection.add(new TransactionHistoryModel(transaction))
            })
        }

        function checkResponse(data) {
            if (data.status !== 1) {
                throw new ErrorService({
                    source: 'TransactionHistoryService',
                    type: Const.error.type.VALIDATION,
                    code: data.code,
                    severity: 'warning',
                    data: {response: data}
                });
            }
            return data;
        }

        function clear() {
            log('clear transactionHistory service');
            self.collection && self.collection.clear();
            self.collection = null;
        }

        return this;
    }]);